<template>
  <b-row >
    <b-col cols="12" xl="9" lg="8">
      <slot />
    </b-col>
    <b-col cols="12" xl="3" lg="4">
      <slot name="sidebar" />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from "bootstrap-vue";

export default {
  components: {
    BRow,
    BCol,
  },
};
</script>
